import React from 'react'
import Modal from '@components/Modal'
import {useApolloQuery as useQuery} from 'apollo-hooks'
import gql from 'graphql-tag'

export default function SpoonityTerms({close, termsType}) {
  const {spoonityTermsAndConditions} = useQuery({
    query: gql`
      query spoonityTermsAndConditions($termsType: String) {
        spoonityTermsAndConditions(termsType: $termsType)
      }
    `,
    variables: {termsType},
    omit: !termsType,
    fetchPolicy: 'network-only'
  })

  if (!spoonityTermsAndConditions) {
    return null
  }

  return (
    <Modal close={close}>
      <div
        className="whitespace-pre-line"
        dangerouslySetInnerHTML={{__html: spoonityTermsAndConditions}}
      />
    </Modal>
  )
}
